import ApiService from "@/core/services/api.service";

// action types
export const LIST_PERMISSIONS = "list_permissions";
export const SHOW_PERMISSIONS_INFO = "show_permission_info";
export const ADD_PERMISSIONS = "add_permission";
export const EDIT_PERMISSIONS = "edit_permission";
export const DELETE_PERMISSIONS = "delete_permission";

// mutation types
export const SET_ERROR = "setErrorPermissions";

const actions = {
    [LIST_PERMISSIONS](context) {
        return new Promise(resolve => {
            ApiService.post("show_permissions", {})
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [SHOW_PERMISSIONS_INFO](context, payload) {
        return new Promise(resolve => {
            ApiService.post("show_permission_info", payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [ADD_PERMISSIONS](context, payload) {
        return new Promise(resolve => {
            ApiService.post("add_permission", payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [EDIT_PERMISSIONS](context, payload) {
        return new Promise(resolve => {
            ApiService.post("edit_permission", payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [DELETE_PERMISSIONS](context, payload) {
        return new Promise(resolve => {
            ApiService.post("delete_permission", payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
};

export default {
    actions
};
